import { Button } from "@/components/ui/button";
import { Menu, X, LogOut, User } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import LanguageToggle from "@/components/LanguageToggle";
import logoWhite from "@/assets/DB_LOGO_WHITE.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();
  const { user, loading, signOut } = useAuth();

  const navLinks = [
    { label: t("Digital Bridge PRO", "ديجيتال بريدج برو"), href: "/pro" },
    { label: t("Consultation", "الاستشارات"), href: "/consultation" },
    { label: t("Services", "الخدمات"), href: "/services" },
    { label: t("Influencers", "المؤثرين"), href: "/influencers" },
  ];


  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo - Keep LTR for brand consistency */}
          <a href="/" className="flex items-center" dir="ltr">
            <img src={logoWhite} alt="Digital Bridge - Marketing Solutions & Digital Agency Logo" className="h-6 lg:h-7" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-4 xl:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-white/70 hover:text-white transition-colors font-medium text-sm whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop Language Toggle */}
          <div className="hidden lg:flex items-center gap-4">
            <LanguageToggle />
            {!loading && user && (
              <div className="flex items-center gap-3">
                <span className="text-sm text-white/70 flex items-center gap-1">
                  <User className="w-4 h-4" />
                  {user.email?.split("@")[0]}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={signOut}
                  className="border-white/20 text-white/70 hover:text-white hover:bg-white/10"
                >
                  <LogOut className="w-4 h-4 me-1" />
                  {t("Logout", "تسجيل الخروج")}
                </Button>
              </div>
            )}
          </div>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden flex items-center gap-1">
            <LanguageToggle compact />
            <button
              className="p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-white" />
              ) : (
                <Menu className="w-6 h-6 text-white" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/10 bg-black">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-white/70 hover:text-white transition-colors font-medium py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              {user && (
                <div className="pt-4 border-t border-white/10">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-white/70 flex items-center gap-1">
                      <User className="w-4 h-4" />
                      {user.email?.split("@")[0]}
                    </span>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => { signOut(); setIsMenuOpen(false); }}
                      className="border-white/20 text-white/70 hover:text-white hover:bg-white/10"
                    >
                      <LogOut className="w-4 h-4 me-1" />
                      {t("Logout", "تسجيل الخروج")}
                    </Button>
                  </div>
                </div>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
